<template>
  <article-layout
    :title="title"
    :media="media"
    :lead="lead"
    :caption="caption"
    :nid="nid"
  >
    <template #meta>
      <figure class="logo">
        <MediaImage
          v-if="logo"
          :image="logo.image"
          :image-style="benefitLogo"
        />
      </figure>

      <article-layout-meta
        v-if="categories"
        :title="$texts('categories', 'Kategorien')"
      >
        <link-list :links="[categories]" link-class="tag is-warning" />
      </article-layout-meta>
    </template>
    <template #content>
      <div v-if="benefit" class="mb-4 content">
        <h4 class="title is-5 mb-1">
          {{ $texts('your_benefit', 'Dein Vorteil') }}:
        </h4>
        <div v-html="benefit" />
      </div>

      <div v-if="group" class="mb-4 content">
        <h4 class="title is-5 mb-1">
          {{ $texts('who_benefits', 'Wer profitiert davon') }}:
        </h4>
        <div>{{ group.title }}</div>
      </div>

      <div v-if="saving" class="mb-4 content">
        <h4 class="title is-5 mb-1">
          {{ $texts('your_savings', 'Deine Einsparung') }}:
        </h4>
        <div v-html="saving" />
      </div>

      <div v-if="hint" class="mb-4 content">
        <h4 class="title is-5 mb-1">{{ $texts('hint', 'Hinweis') }}:</h4>
        <div v-html="hint" />
      </div>

      <button class="button is-primary is-rounded" @click="profit">
        {{ $texts('profitNow', 'Profitiere jetzt') }}
      </button>
    </template>
    <template #modal>
      <o-modal v-model:active="isComponentModalActive">
        <div v-if="!user.loggedIn">
          <NodeBenefitMessage />
        </div>
        <div v-if="user.loggedIn && !user.isPremium">
          <NodeBenefitMessageUpgrade />
        </div>
        <div v-if="user.loggedIn && user.isPremium && !user.hasImage">
          <NodeBenefitMessagePicture />
        </div>
        <div v-if="user.loggedIn && user.isPremium && user.hasImage">
          <template v-if="benefitType === 'info' && popup">
            <NodeBenefitMessageInfo :text="popup" />
          </template>
          <template v-else>
            <NodeBenefitMessageDownload :benefit="nid" />
          </template>
        </div>
      </o-modal>
    </template>
    <template #footer>
      <!--      <node-benefit-related :nid="nid" :tid="categorieId" />-->
    </template>
  </article-layout>
</template>

<script setup lang="ts">
import type { NodeBenefitFragment } from '#graphql-operations'

const props = defineProps<NodeBenefitFragment>()

const isComponentModalActive = ref(false)

const benefitLogo = defineImageStyle({
  type: 'pictures',
  pictures: {
    sm: {
      width: 200,
    },
  },
})

const user = useDrupalUser()
const { $texts } = useNuxtApp()

const caption = computed(() => props.media?.caption ?? '')

const profit = () => {
  isComponentModalActive.value = true
  const gtm = useGtm()
  gtm?.trackEvent({
    event: 'profit_now',
    nid: props.nid,
    title: props.title,
    uid: user.value.uid,
  })
}
</script>
